import { render, staticRenderFns } from "./CompanyProfileBankInfo.vue?vue&type=template&id=b20427fa&scoped=true&"
import script from "./CompanyProfileBankInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyProfileBankInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfileBankInfo.vue?vue&type=style&index=0&id=b20427fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20427fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VDivider,VProgressCircular,VRow,VSnackbar})
